/* Athleia lookbook */
(function () {
  if (customElements.get('athleia-lookbook')) return;
  var SIZE_ORDER = ['XXS','XS','S','M','L','XL','XXL','2XL','3XL'];
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class AthleiaLookbook extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      this.allFigs = Array.prototype.slice.call(this.querySelectorAll('[data-fig]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-look-panel]'));
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-tab]'));
      this.curEl = this.querySelector('[data-cur]'); this.totEl = this.querySelector('[data-tot]');
      this.lookNo = this.querySelector('[data-lookno]'); this.progress = this.querySelector('[data-progress]');
      this.autoplay = this.dataset.autoplay === 'true' && !prefersReduced;
      this.speed = Math.max(3, parseFloat(this.dataset.speed || '4')) * 1000;
      this.paused = false; this.visible = true; this.holdUntil = 0;
      var me = this;
      this.allFigs.forEach(function (f) {
        var img = f.querySelector('img');
        if (!img || !img.dataset.fallback) return;
        var swap = function () {
          if (img.dataset.swapped) return;
          img.dataset.swapped = '1'; f.classList.add('is-photo');
          img.addEventListener('load', function () { if (me.figs) me.layout(true); }, { once: true });
          img.src = img.dataset.fallback;
        };
        if (img.complete && img.naturalWidth === 0) swap();     /* failed before this script ran */
        else img.addEventListener('error', swap, { once: true });
      });
      this.sortSizes(); this.bindProducts(); this.bindUi();
      this.setGender(this.dataset.start || 'women', true);
      this.startTimer();
      var self = this;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { self.visible = es[0].isIntersecting; }, { threshold: .25 }).observe(this);
      }
      window.addEventListener('resize', function () { self.layout(true); });
      document.addEventListener('visibilitychange', function () { self.visible = !document.hidden; });
      document.addEventListener('shopify:block:select', function (e) {
        var i = self.figs ? self.figs.findIndex(function (f) { return f.dataset.look === e.detail.blockId; }) : -1;
        if (i < 0) { var f = self.allFigs.find(function (x) { return x.dataset.look === e.detail.blockId; }); if (f) { self.setGender(f.dataset.gender); i = self.figs.indexOf(f); } }
        if (i >= 0) { self.go(i); self.paused = true; }
      });
    }

    /* ---------- carousel ---------- */
    setGender(g, initial) {
      if (!this.allFigs.some(function (f) { return f.dataset.gender === g; })) g = this.allFigs.length ? this.allFigs[0].dataset.gender : 'women';
      this.gender = g;
      this.tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.tab === g ? 'true' : 'false'); });
      this.figs = this.allFigs.filter(function (f) { return f.dataset.gender === g; });
      this.allFigs.forEach(function (f) { f.hidden = f.dataset.gender !== g; });
      this.front = 0; this.rel = {};
      this.totEl.textContent = String(this.figs.length).padStart(2, '0');
      this.layout(true); this.showPanel();
      if (!initial) this.kick();
    }
    slots() {
      var w = this.stage.clientWidth, mobile = w < 640;
      return mobile
        ? { x: [.66, .40, .21, .08, -.04], s: [.9, .64, .5, .41, .35], y: [0, .03, .05, .065, .075] }
        : { x: [.70, .48, .31, .18, .07], s: [1, .74, .57, .46, .38], y: [0, .035, .06, .078, .09] };
    }
    place(f, state, n, instant) {
      /* state: integer slot (0 = front) | 'left' (faded out past the back) | 'right' (parked offscreen, next to enter) */
      var w = this.stage.clientWidth, h = this.stage.clientHeight, S = this.slots();
      var K = Math.max(0, Math.min(S.x.length - 1, n - 2));
      var img = f.querySelector('img');
      var fh = f.clientHeight || h * .92;
      var iw = img && img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight * fh : fh * .45;
      var x, s, y, o = 1, z;
      if (state === 'left') { x = (S.x[K] - .2) * w; s = S.s[K] * .9; y = S.y[K] * h; o = 0; z = 1; }
      else if (state === 'right') { x = 1.2 * w; s = 1.04; y = 0; o = 0; z = 31; }
      else { var r = Math.min(state, K); x = S.x[r] * w; s = S.s[r]; y = S.y[r] * h; z = 30 - r; if (r === 0) z = 32; }
      f.classList.toggle('is-instant', !!instant);
      f.style.zIndex = z;
      f.style.opacity = o;
      f.style.transform = 'translate3d(' + (x - iw / 2).toFixed(1) + 'px,' + (-y).toFixed(1) + 'px,0) scale(' + s.toFixed(3) + ')';
      f.classList.toggle('is-front', state === 0);
      f.tabIndex = o ? 0 : -1;
      f.setAttribute('aria-hidden', o ? 'false' : 'true');
    }
    stateOf(rel, n) {
      var K = Math.max(0, Math.min(this.slots().x.length - 1, n - 2));
      if (n === 1) return 0;
      if (rel <= K) return rel;
      if (rel < n - 1) return 'left';
      return 'right';
    }
    layout(instant) {
      var n = this.figs.length, self = this;
      this.figs.forEach(function (f, i) {
        var rel = ((self.front - i) % n + n) % n;
        var old = self.rel[i];
        var st = self.stateOf(rel, n), ost = old === undefined ? null : self.stateOf(old, n);
        self.rel[i] = rel;
        if (!instant && ost !== null && ost !== st) {
          if (st === 'right' && ost !== 0) {                        /* leaving past the back: fade out left, then park right */
            self.place(f, 'left', n, false);
            setTimeout(function () { if (self.rel[i] === rel) self.place(f, 'right', n, true); }, 700);
            return;
          }
          if (ost === 'right' && st !== 0) {                        /* stepping back: come in from the left */
            self.place(f, 'left', n, true); void f.offsetWidth;
          }
          if (ost === 'left' && st === 'right') { self.place(f, 'right', n, true); return; }
        }
        self.place(f, st, n, instant);
      });
      if (instant) requestAnimationFrame(function () { requestAnimationFrame(function () { self.figs.forEach(function (f) { f.classList.remove('is-instant'); }); }); });
      this.curEl.textContent = String(this.figs.length ? this.front + 1 : 0).padStart(2, '0');
    }
    go(i) { var n = this.figs.length; if (!n) return; this.front = ((i % n) + n) % n; this.layout(false); this.showPanel(); this.kick(); }
    next() { this.go(this.front + 1); }
    prev() { this.go(this.front - 1); }
    showPanel() {
      var f = this.figs[this.front]; if (!f) return;
      var id = f.dataset.look;
      this.panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.lookPanel === id); });
      if (this.lookNo) this.lookNo.textContent = 'Look ' + String(this.front + 1).padStart(2, '0') + ' / ' + String(this.figs.length).padStart(2, '0');
    }

    /* ---------- autoplay ---------- */
    kick() { this.t0 = performance.now(); }
    hold(ms) { this.holdUntil = performance.now() + (ms || 12000); this.kick(); }
    startTimer() {
      var self = this; this.kick();
      var tick = function (now) {
        var active = self.autoplay && !self.paused && self.visible && now > self.holdUntil && self.figs.length > 1;
        if (active) {
          var u = (now - self.t0) / self.speed;
          if (self.progress) self.progress.style.width = Math.min(100, u * 100) + '%';
          if (u >= 1) self.next();
        } else {
          if (self.progress) self.progress.style.width = '0%';
          if (!self.paused) self.t0 = now - 0;
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    /* ---------- ui ---------- */
    bindUi() {
      var self = this;
      this.querySelector('[data-next]').addEventListener('click', function () { self.next(); self.hold(); });
      this.querySelector('[data-prev]').addEventListener('click', function () { self.prev(); self.hold(); });
      this.tabs.forEach(function (t) { t.addEventListener('click', function () { if (t.dataset.tab !== self.gender) { self.setGender(t.dataset.tab); self.hold(6000); } }); });
      this.allFigs.forEach(function (f) {
        f.addEventListener('click', function () { if (self.swiped) return; var i = self.figs.indexOf(f); if (i >= 0 && i !== self.front) { self.go(i); self.hold(); } });
      });
      this.addEventListener('mouseenter', function () { self.paused = true; });
      this.addEventListener('mouseleave', function () { self.paused = false; self.kick(); });
      this.addEventListener('focusin', function () { self.paused = true; });
      this.addEventListener('focusout', function () { self.paused = false; self.kick(); });
      this.stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { self.next(); self.hold(); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { self.prev(); self.hold(); e.preventDefault(); }
      });
      var sx = null, sy = null;
      this.stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
      this.stage.addEventListener('pointerup', function (e) {
        if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { dx < 0 ? self.next() : self.prev(); self.hold(); self.swiped = true; setTimeout(function () { self.swiped = false; }, 350); }
      });
      this.stage.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', function () { self.layout(true); }, { once: true }); });
    }

    sortSizes() {
      this.querySelectorAll('[data-sizes]').forEach(function (fs) {
        var b = Array.prototype.slice.call(fs.querySelectorAll('[data-size]'));
        b.sort(function (a, c) {
          var ia = SIZE_ORDER.indexOf(a.textContent.trim().toUpperCase()), ic = SIZE_ORDER.indexOf(c.textContent.trim().toUpperCase());
          return (ia < 0 ? 99 : ia) - (ic < 0 ? 99 : ic);
        });
        b.forEach(function (x) { fs.appendChild(x); });
      });
    }

    /* ---------- products & cart ---------- */
    bindProducts() {
      var self = this;
      this.panels.forEach(function (panel) {
        var items = Array.prototype.slice.call(panel.querySelectorAll('[data-item]'));
        var addAll = panel.querySelector('[data-add-all]');
        var refreshAll = function () {
          if (!addAll) return;
          var ready = items.every(function (it) { return self.variantOf(it); });
          addAll.disabled = !ready;
          addAll.textContent = ready ? 'Add the full look' : 'Select sizes to add the full look';
        };
        items.forEach(function (it) {
          var add = it.querySelector('[data-add]'), msg = it.querySelector('[data-msg]');
          it.querySelectorAll('[data-size]').forEach(function (b) {
            b.addEventListener('click', function () {
              it.querySelectorAll('[data-size]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
              add.disabled = false; add.textContent = 'Add to bag'; msg.textContent = ''; msg.classList.remove('is-error');
              refreshAll(); self.hold(20000);
            });
          });
          add.addEventListener('click', function () {
            var id = self.variantOf(it); if (!id) return;
            self.addToCart([id], add, msg);
          });
        });
        if (addAll) addAll.addEventListener('click', function () {
          var ids = items.map(function (it) { return self.variantOf(it); });
          if (ids.some(function (x) { return !x; })) return;
          self.addToCart(ids, addAll, panel.querySelector('[data-msg-all]'));
        });
      });
    }
    variantOf(it) {
      var fixed = it.querySelector('[data-variant-fixed]');
      if (fixed) return fixed.dataset.available === 'true' ? fixed.value : null;
      var sel = it.querySelector('[data-size][aria-pressed="true"]');
      return sel ? sel.dataset.variantId : null;
    }
    addToCart(ids, btn, msg) {
      var self = this, label = btn.textContent;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      btn.disabled = true; btn.textContent = 'Adding…';
      if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
      var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { throw new Error(res.description || res.message || 'Could not add to bag'); }
          var lines = res.items || [res];
          if (window.publish && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'athleia-lookbook', productVariantId: ids[0], cartData: res }); } catch (e) {}
          }
          if (cart && typeof cart.renderContents === 'function' && res.sections) {
            cart.classList.remove('is-empty');
            cart.renderContents({ key: lines[lines.length - 1].key, sections: res.sections });
          } else if (!cart) {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          btn.textContent = ids.length > 1 ? 'Look added ✓' : 'Added ✓';
          if (msg) msg.textContent = ids.length > 1 ? 'The full look is in your bag.' : 'Added to your bag.';
          setTimeout(function () { btn.disabled = false; btn.textContent = label === 'Adding…' ? 'Add to bag' : label; }, 2200);
        })
        .catch(function (err) {
          btn.disabled = false; btn.textContent = label;
          if (msg) { msg.textContent = err.message; msg.classList.add('is-error'); }
        });
    }
  }
  customElements.define('athleia-lookbook', AthleiaLookbook);
})();